<template>
  <div class="Nav__Container">
    <Home v-if="step === 0" />
    <Shape v-if="step === 1" />
    <Texture v-if="step === 2" />
    <Save v-if="step === 3" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Home from '@/components/Home/Home'
import Shape from '@/components/Shape/Shape'
import Texture from '@/components/Texture/Texture'
import Save from '@/components/Save/Save'

export default {
  components: {
    Home,
    Shape,
    Texture,
    Save
  },
  computed: {
    ...mapGetters(['step'])
  }
}
</script>

<style scoped>
.Nav__Container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
</style>
